import type { TFunction } from 'i18next';

/** 客户平台账单状态码 → i18n（与筛选下拉一致，不依赖后端 billStatusLabel 文案） */
const PORTAL_BILL_STATUS_I18N: Record<string, string> = {
    '4': 'billList.filters.status.pendingExternalConfirm',
    '6': 'billList.filters.status.externalRejected',
    '7': 'billList.filters.status.externalConfirmed',
};

export const getPortalBillStatusLabel = (
    billStatus: string,
    t: TFunction,
    fallbackLabel?: string,
): string => {
    const key = PORTAL_BILL_STATUS_I18N[billStatus];
    if (key) {
        return t(key);
    }
    return fallbackLabel?.trim() ? fallbackLabel : billStatus;
};
